import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

import SakeDatasPage from './pages/SakeDatasPage'
import SakeBrewersPage from './pages/SakeBrewersPage';
import LiquorShopsPage from './pages/LiquorShopsPage'

const App = () => {
  return (
    <div className="text-gray-600 body-font">
      <Router>
        <div className="container mx-auto p-5">
          {/* ヘッダー */}
          <div className="flex items-center mb-4">
            <span className="title-font font-medium text-gray-900 text-xl">
              ProjectErin
            </span>
          </div>

          {/* ナビゲーション */}
          <nav className="flex space-x-4 mb-6 border-b pb-2">
            <Link
              to="/SakeDatasPage"
              className="hover:underline hover:decoration-gray-500"
            >
              日本酒データ
            </Link>
            <Link 
              to="/SakeBrewersPage" 
              className="hover:underline hover:decoration-gray-500"
            >
              酒蔵リスト
            </Link>
            <Link 
              to="/LiquorShopsPage" 
              className="hover:underline hover:decoration-gray-500"
            >
              酒屋リスト
            </Link>
          </nav>

          {/* ページコンテンツ */}
          <div>
            <Routes>
              <Route path="/SakeDatasPage" element={<SakeDatasPage />} />
              <Route path="/SakeBrewersPage" element={<SakeBrewersPage />} />
              <Route path="/LiquorShopsPage" element={<LiquorShopsPage />} />
            </Routes>
          </div>
        </div>
      </Router>
    </div>
  );
};

export default App;